// extracted by mini-css-extract-plugin
export default {"ClientNote__address":"styles_ClientNote__address__uFBtJ","ClientNote__noteTitle":"styles_ClientNote__noteTitle__BAIdQ"};